import React from "react";
import { t } from "ttag";

import { Image } from "../../../common/Image";
import { DropdownHeadersType } from "../../../templates/ShopTileTemplate";
import { Dropdown } from "../Dropdown";
import BlankCompareTileImage from "./blank_compare_tile.svg";

import styles from "./index.module.scss";

interface ICompareTileProps {
    dropdownHeaders: DropdownHeadersType;
    handleSelectProduct?: (oldTile: number, newTile: number) => void;
    selectedProducts?: number[];
}

export const BlankCompareTile = (props: ICompareTileProps) => {
    return (
        <div className={styles.container}>
            <div className={styles.contentContainer}>
                <Image
                    alt={t`Blank Compare Product`}
                    src={BlankCompareTileImage}
                />
                <Dropdown
                    dropdownHeaders={props.dropdownHeaders}
                    handleSelectProduct={props.handleSelectProduct}
                    selectedProducts={props.selectedProducts}
                />
            </div>
        </div>
    );
};
